import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询版本更新记录列表
export const getVersionRecordList = params => {
    return reqGet("get", "/app-yijiu-backstage/getVersionRecordList", params);
};

// 删除版本更新记录
export const deleteVersionRecord = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteVersionRecord", params);
};

// 修改版本更新记录
export const updateVersionRecord = params => {
    return req("post", "/app-yijiu-backstage/updateVersionRecord", params);
  };

  
// 添加版本更新记录
export const addVersionRecord = params => {
    return req("post", "/app-yijiu-backstage/addVersionRecord", params);
  };
  



// WEBPACK FOOTER //
// ./src/api/manage/versionRecord.js